var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c7n-saga-img" },
    [
      _c(
        "div",
        {
          staticClass: "c7n-saga-img-circle",
          class: { circleActive: _vm.type === "input" },
          on: {
            click: function ($event) {
              return _vm.showData("input", "输入数据", _vm.data.input)
            },
          },
        },
        [_vm._v(" Input ")]
      ),
      _c("div", { staticClass: "c7n-saga-img-line" }),
      [
        _vm._l(_vm.data.tasks, function (taskList, index) {
          return [
            _c(
              "div",
              { key: "squares" + index, staticClass: "c7n-saga-img-squares" },
              _vm._l(taskList, function (taskObj, taskIndex) {
                return _c(
                  "div",
                  {
                    key: taskIndex + "_" + taskObj.id,
                    staticClass: "c7n-saga-img-square",
                    class: {
                      failed: taskObj.status === "FAILED",
                      completed: taskObj.status === "COMPLETED",
                      other:
                        taskObj.status === "RUNNING" ||
                        taskObj.status === "NON_CONSUMER" ||
                        taskObj.status === "WAIT_TO_BE_PULLED",
                      circleActive:
                        _vm.type === index + "_" + taskIndex + "_" + taskObj.id,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.showDetail(index, taskIndex, taskObj)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(taskObj.taskCode))]),
                    _c("span", [_vm._v(_vm._s(taskObj.description))]),
                  ]
                )
              }),
              0
            ),
            _c("div", {
              key: "line" + index,
              staticClass: "c7n-saga-img-line",
            }),
          ]
        }),
      ],
      _c(
        "div",
        {
          staticClass: "c7n-saga-img-circle",
          class: { circleActive: _vm.type === "output" },
          on: {
            click: function ($event) {
              return _vm.showData("output", "输出数据", _vm.data.output)
            },
          },
        },
        [_vm._v(" Output ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }